import { FC, useMemo, PropsWithChildren } from "react";
import { DisableGroupContext, DisableGroupContextValue } from "./DisableGroupContext";
import { useDisabled } from "./useDisabled";

/**
 * The `DisableGroup` component properties.
 */
export interface DisableGroupProps {
  /**
   * Indicates whether descendent components, which are able to be disabled, should be.
   */
  readonly disabled?: boolean;
}

/**
 * A component which allows for the disabling and enabling of supporting descendent components.
 */
export const DisableGroup: FC<PropsWithChildren<DisableGroupProps>> = (props) => {
  const { children } = props;

  const disabled = useDisabled(props);

  const contextValue = useMemo(
    (): DisableGroupContextValue => ({
      disabled,
    }),
    [disabled],
  );

  return <DisableGroupContext.Provider value={contextValue}>{children}</DisableGroupContext.Provider>;
};
